import { Alert } from '@/ui/primitives';
import { cafHealthFor } from '../data';
import type { ClienteListItem } from '../schemas';

interface Props {
  clientes: ClienteListItem[];
}

export function CafAlertBanner({ clientes }: Props) {
  let vencidos = 0;
  let vencendo = 0;
  for (const c of clientes) {
    const h = cafHealthFor(c.caf_data_validade);
    if (h === 'vencido') vencidos++;
    else if (h === 'vencendo') vencendo++;
  }

  if (vencidos === 0 && vencendo === 0) return null;

  const partes: string[] = [];
  if (vencidos > 0) partes.push(`${vencidos} vencido${vencidos > 1 ? 's' : ''}`);
  if (vencendo > 0) partes.push(`${vencendo} vencendo em até 30 dias`);

  return (
    <Alert tone="warn" title="Atenção a CAFs da carteira">
      {partes.join(' · ')}.
    </Alert>
  );
}
